import { createSelector } from "reselect"
import { find } from "lodash"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getForecasts } from "modules/portfolio-root/selectors/forecast"
import { getDisplayTypeName, getForecastId } from "./items"
import { computeFileName } from "helpers/analyze"

const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate

export const getScreenName = createSelector(
  [getForecasts, getForecastId],
  (forecasts, forecastId) => {
    if (forecastId) {
      const forecast = find(forecasts, ({ id }) => id === forecastId)
      if (forecast) {
        return `${forecast.name} % Expected Return`
      }
    }
    return "Forecast"
  },
)

export const getFileName = createSelector(
  [getPortfolioName, getDisplayTypeName, getViewType, getScreenName, getStartDate, getEndDate],
  computeFileName,
)
